// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';

// Internal Dependencies
import styles from '../styles/Styles';

// Local variables
const propTypes = {
  attendanceCount: PropTypes.number,
  badgeCount: PropTypes.number,
};

const thisStyle = styles.coderCardMetrics;

// Component definition
const CoderCardMetrics = (props) => {
  const {
    attendanceCount,
    badgeCount,
  } = props;

  return (
    <Table multiSelectable={false} style={thisStyle.mainSection}>
      <TableBody displayRowCheckbox={false}>
        <TableRow>
          <TableRowColumn style={thisStyle.CoderMetricRowOne}>{badgeCount}</TableRowColumn>
          <TableRowColumn style={thisStyle.CoderMetricRowOne}>{attendanceCount}</TableRowColumn>
        </TableRow>
        <TableRow>
          <TableRowColumn style={thisStyle.CoderMetricRowTwo}>Badges</TableRowColumn>
          <TableRowColumn style={thisStyle.CoderMetricRowTwo}>Attendance</TableRowColumn>
        </TableRow>
      </TableBody>
    </Table>
  );
};

CoderCardMetrics.propTypes = propTypes;
export default CoderCardMetrics;



/** WEBPACK FOOTER **
 ** ./src/ninjas/CoderCardMetrics.js
 **/